import { MappingItemFormValues } from 'pages/GatewayRules/components/GatewayRulesForm/hooks/useGatewayRulesForm';

export function getInitialMappingItem(): Nullable<MappingItemFormValues> {
  return {
    commissions: [],
    gateway: null,
    merchantAccount: null,
    value: 100,
    subagent: null,
  };
}
